import { reviewCardBlueprint } from "@made-people/blueprint-review-card/blueprint";

reviewCardBlueprint.override({
  slots: {
    base: "w-full bg-beige-50 rounded-lg p-4 lg:px-6 lg:py-4 h-full shadow-sm border border-beige-200 grid grid-cols-2",
    star: "data-[is-active=false]:opacity-30 text-[20px] text-yellow-300",
    starContainer: "mb-4 col-span-2",
    review: "text-balance mb-auto col-span-2",
    author:
      "text-body-sm lg:text-body-md mt-8 !font-bold col-span-1 flex self-end",
    collectedBy:
      "flex items-center text-label-sm text-text-less-emphasis-1 gap-1 col-span-1 mt-8 justify-end h-[22px] lg:h-[26px] self-end",
  },
});
